/**
 * author: Ananthapadmanabhan V K
 */
import React from "react";
import PropTypes from "prop-types";
import "./SAdminHeader.scss";
import {
  Button,
  input,
  Navbar,
  Container,
  Nav,
  NavDropdown,
  Dropdown,
  Accordion,
  DropdownButton,
} from "react-bootstrap";
import { BiMenu, BiBell, BiSearch, BiUser } from "react-icons/bi";
import { withTranslation } from "react-i18next";
import LogoutService from "../../../core/service/LogoutService";
import { useNavigate } from "react-router-dom";
import Utils from "../../../core/utilities/Utils";
import Admin_logo from "../../../images/Ecodrisil_logo.png"

const SAdminHeader = ({ t }) => {
  const navigate = useNavigate();
  var lsData = localStorage.getItem("authority");
  var profileData = null;
  if (lsData !== "") {
    profileData = JSON.parse(lsData).profile.user;
  }

  const logout = () => {
    LogoutService.logout()
      .then((response) => {
        localStorage.clear();
        navigate("/login");
      })
      .catch((error) => {
        localStorage.clear();
        navigate("/login");
        console.log("err", error);
      });
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="light"
      className="px-2 SAdminHeader py-0"
      sticky="top"
    >
      <Navbar.Brand href="">
        <BiMenu></BiMenu>
      </Navbar.Brand>
      <Navbar.Brand className="Admin_NavbarBrand" href="#">
        <img src={Admin_logo} className="profileImg" />
      </Navbar.Brand>
      <Navbar id="responsive-navbar-nav" className="ms-auto p-0">

        <Nav>
          <Nav.Link href="#">
            <BiSearch />
          </Nav.Link>
          
          <Nav.Link href="#">
            <BiBell />
          </Nav.Link>

          <Dropdown className="dropright" id="dropdown-menu-align-end">
            <Dropdown.Toggle
              variant="drop1 nav-icon Profile_navicon"
              id="dropdown-basic"
            >
              <div className="Userprofile_iconBox_header">
                {/* <BiUser /> */}
                <p className="initials-custom">{Utils.nameInitials(profileData.name)}</p>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <div className="Header_dropdownbox short_profile-view">
                <ul>
                  <li>
                    <a href="#" className="short_profile-view_head">
                      <div className="Userprofile_iconBox_header">
                        <BiUser />
                      </div>
                      <h6 className="m-0">{profileData.name}</h6>
                    </a>
                  </li>
                  <li>
                    <a href="#">{t("ProfileDetails.label")}</a>
                  </li>
                  <li>
                    <a href="#" onClick={logout}>
                      {t("Logout.label")}
                    </a>
                  </li>
                </ul>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar>
    </Navbar>
  );
};

export default withTranslation()(SAdminHeader);
